<template>
<div class="chapter">
<div class="inner_page">
<p class="dedt">Acknowledgements</p>
<p class="ded">I would like to thank the Search Press team, especially May Corfield and Katie French. Thanks to Rico Design and Sirdar for providing the yarn for this book. And thanks to family, friends and colleagues who have had to put up with my crochet ramblings.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Acknowledgements.vue?3557a051